/**
 * Capability names the Capabilities API returns. They are platform contract values, the same for
 * every app, so they live here and not in one app. The API list is open: a name not listed here
 * still parses and is ignored until an app needs it, then it is added here.
 */
export const CAPABILITY_KEYS = {
  AI_INSIGHTS: 'ai_insights',
  AI_VISIBILITY: 'ai_visibility',
  LSG_REPORTS_ENABLED: 'lsg_reports_enabled',
  /** Local Search Grid: the schedules (adhoc, weekly, monthly) the plan allows for LSG reports. */
  GRC_ALLOWED_SCHEDULES: 'grc_allowed_schedules',
  /** Local Search Grid: the most keywords the plan allows in one LSG report. */
  GRC_NUM_KEYWORDS: 'grc_num_keywords',
  RM_ALLOWED: 'rm_allowed',
  RM_LOCATION_ENABLED: 'rm:location:enabled',
  AS_LOCATION_ENABLED: 'as:location:enabled',
  AS_PLUS_LOCATION_ENABLED: 'as_plus:location:enabled',
  AS_LOCATION_SHOW_ADVERTISEMENT: 'as:location:show_advertisement',
  AS_PLUS_LOCATION_SHOW_ADVERTISEMENT: 'as_plus:location:show_advertisement'
} as const;

/** A known capability name */
export type CapabilityKey = (typeof CAPABILITY_KEYS)[keyof typeof CAPABILITY_KEYS];
